import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import routes from 'app/routes';

import Step from './Step';
import SessionButton from './SessionStep/SessionButton';

export default function SessionStep({
  step, programId, showStep, setShowStep,
}) {
  return (
    <Step
      step={step}
      iconClassName="counting-icon bg-white"
      showStep={showStep}
      setShowStep={setShowStep}
    >
      <>
        {step.is_scheduled_or_rescheduled && <SessionButton step={step} programId={programId} />}

        {step.is_topic_changeable && (
          <Link
            to={routes.members.programs.program.step.changeTopic(step.id)}
            className="btn btn-light btn-reverse ms-3 mb-3 mb-lg-0 step-action-btn"
            preventScrollReset
          >
            Change Topic!
          </Link>
        )}
      </>
    </Step>
  );
}

SessionStep.propTypes = {
  step: PropTypes.object.isRequired,
  programId: PropTypes.number.isRequired,
  showStep: PropTypes.bool.isRequired,
  setShowStep: PropTypes.func.isRequired,
};
